import { useEffect, useState } from "react";

import DeleteIcon from "@material-ui/icons/Delete";

import { getLocalValue } from "../../utils/auth";
import Button from "../Button";
import Select from "../Select";
import TextField from "../TextField";

import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

function SubSubject({
  subjectIndex,
  handleChange,
  data,
  dataType,
  conditionToPassList,
  frameworkList,
  onDelete,
  sessionType,
  ...props
}) {
  const { t } = useTranslation();
  const userRole = getLocalValue("u_coaching_role_db");
  const [subCategoryObj, setSubCategoryObj] = useState(data);

  useEffect(() => {
    setSubCategoryObj(data);
    //console.log("frameworkList", frameworkList);
  }, [data]);

  const handleSubCategoryChange = (val, key, index) => {
    let currentObj = [...subCategoryObj];
    currentObj[index][key] = val;
    setSubCategoryObj(currentObj);
    handleChange(currentObj, subjectIndex);
  };

  const addNewSubSubject = () => {
    let obj = {
      condition_to_pass: "",
      data_type: "",
      framework: "",
      sub_subject: "",
      u_role: userRole,
    };
    setSubCategoryObj([...subCategoryObj, obj]);
  };

  const deleteSubCat = index => {
    let currentObj = [...subCategoryObj];
    if (currentObj[index].id) {
      onDelete(currentObj[index].id);
    }
    currentObj.splice(index, 1);
    setSubCategoryObj(currentObj);
    handleChange(currentObj, index);
  };
  return (
    <div className={styles.wrapper}>
      {!props.hideHeader && subCategoryObj && subCategoryObj.length > 0 && (
        <div className={`${styles.row} ${styles.head}`}>
          <div>{t("subjectManagement.subCategory")}</div>
          <div>{t("subjectManagement.dataType")}</div>
          {frameworkList.some(item => item.type === sessionType && item.value === 1) && (
            <>
              <div>{t("subjectManagement.conditionToPass")}</div>
            </>
          )}
          <div>{t("subjectManagement.framework")}</div>
          <div></div>
        </div>
      )}


      {subCategoryObj &&
        subCategoryObj.map((subCat, index) => (
          <div className={`${styles.row}`} key={index}>
            <div>
              <TextField
                fullWidth
                variant="outlined"
                label={t("subjectManagement.enterSubCategory")}
                value={subCat.sub_subject}
                onChange={e => {
                  handleSubCategoryChange(e.target.value, "sub_subject", index);
                }}
              />
            </div>
            <div>
              <Select
                placeholder={t("subjectManagement.selectType")}
                value={subCat.data_type.toLowerCase()}
                list={dataType}
                onChange={e => {
                  handleSubCategoryChange(e.target.value, "data_type", index);
                }}
                style={{ marginBottom: "0px" }}
              />
            </div>

            {frameworkList.some(item => item.type === sessionType && item.value === 1) && (
              <>
                <div>
                  <Select
                    placeholder={t("subjectManagement.selectCondition")}
                    value={subCat.condition_to_pass}
                    list={conditionToPassList}
                    onChange={e => {
                      handleSubCategoryChange(e.target.value, "condition_to_pass", index);
                    }}
                    style={{ marginBottom: "0px" }}
                  />
                </div>
              </>
            )}

            <div>
              {/* {
                if(frameworkList.type === )
              } */}
              <Select
                placeholder={t("subjectManagement.selectFramework")}
                value={subCat.framework}
                list={frameworkList.filter(list => list.type === sessionType)}
                //list={frameworkList}
                onChange={e => {
                  handleSubCategoryChange(e.target.value, "framework", index);
                }}
                style={{ marginBottom: "0px" }}
              />
            </div>
            <div>
              <DeleteIcon
                color="action"
                onClick={() => {
                  deleteSubCat(index);
                }}
              />{" "}
            </div>
          </div>
        ))}

      <Button
        style={{ color: "#0A859A", fontSize: "14px" }}
        onClick={addNewSubSubject}
      >
        {" "}
        {t("subjectManagement.addSubCategory")}
      </Button>
    </div>
  );
}

export default SubSubject;